/**
 * @file This file contains configurations for all tooltips in the game.
 * @module tooltipsConfig
 */

export const tooltipsConfig = {
    'place-first-item': {
        id: 'place-first-item',
        content: 'This is your item queue. Click an empty square on the grid to place the first item!',
        target: '#gem-queue',
        showOnce: true,
        dismiss: {
            action: 'game:itemPlaced', // Dismiss when an item is placed
            showCloseButton: false,    // Hide the 'X' to force the action
        },
    },
    'first-merge': {
        id: 'first-merge',
        content: 'Great! Now place two more of the same item next to it to create a merge.',
        target: '#game-grid',
        position: 'bottom',
        showOnce: true,
        dismiss: {
            action: 'achievement:mergeOccurred', // Dismiss after the first merge
            showCloseButton: false,
        }
    },
    'timed-example': {
        id: 'timed-example',
        content: 'This is a timed tooltip that will disappear on its own.',
        target: '#score',
        position: 'bottom',
        dismiss: { duration: 5000 } // Disappears after 5 seconds
    }
};